/**
 * HEADER-PREACCES-JS-V2.LIQUID
 * ============================
 * Lógica del header EXCEPTO búsqueda:
 * - Promo bar y countdown
 * - Menú móvil
 * - Menú desktop con hover (DROPDOWN SHOP REORDENADO)
 * - Carrito
 * - Scroll behavior
 */

document.addEventListener("DOMContentLoaded",function(){

// Valores de Liquid (texto, ajuste del tema, prefijo de idioma): los pinta header-black-comet.liquid.
var CFG = window.YX_HEADER_CFG || {};

// ============================================================
// IN-APP BROWSER SCROLL HELPER
// ============================================================
var _isInApp = document.documentElement.classList.contains('is-inapp-browser');
function getScrollY() {
  if (_isInApp) return document.body.scrollTop || 0;
  return window.pageYOffset || document.documentElement.scrollTop;
}
function getScrollTarget() {
  return _isInApp ? document.body : window;
}

// ============================================================
// SECCIÓN 2: PROMO EXPIRATION CHECK
// ============================================================
(function checkPromoExpiration() {
  const now = new Date();
  const madridFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
  });
  const parts = madridFormatter.formatToParts(now);
  const year = parts.find(p => p.type === 'year').value;
  const month = parts.find(p => p.type === 'month').value;
  const day = parts.find(p => p.type === 'day').value;
  const hour = parts.find(p => p.type === 'hour').value;
  const minute = parts.find(p => p.type === 'minute').value;
  const second = parts.find(p => p.type === 'second').value;
  const nowMadrid = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
  const promoEndDate = new Date('2026-01-25T23:59:59');
  window.YUXUS_PROMO_ACTIVE = nowMadrid < promoEndDate;
  if (!window.YUXUS_PROMO_ACTIVE) {
    document.body.classList.add('promo-expired');
  }
})();

// ============================================================
// SECCIÓN 3: SLIDECART INTEGRATION
// ============================================================
(function() {
  window.SLIDECART_OPEN = function() {
    if (window.YUXUS_CART && window.YUXUS_CART.isReady) { window.YUXUS_CART.open(); }
    else {
      let attempts = 0;
      const interval = setInterval(function() {
        attempts++;
        if (window.YUXUS_CART && window.YUXUS_CART.isReady) { clearInterval(interval); window.YUXUS_CART.open(); }
        else if (attempts > 30) { clearInterval(interval); }
      }, 100);
    }
  };
  window.SLIDECART_CLOSE = function() { if (window.YUXUS_CART && window.YUXUS_CART.close) window.YUXUS_CART.close(); };
})();

function setupCartDrawerLinks() {
  document.querySelectorAll('#desktopCartLink, #mobileCartLink, .mobile-cart-block a').forEach(function(button) {
    button.removeAttribute('onclick');
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (window.YUXUS_CART && window.YUXUS_CART.isReady) { window.YUXUS_CART.open(); }
      else { window.SLIDECART_OPEN(); }
    });
  });
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', setupCartDrawerLinks); }
else { setupCartDrawerLinks(); }

// ============================================================
// SECCIÓN 4: TEXTOS Y CONFIGURACIÓN
// ============================================================
const IS_SPAIN = window.YUXUS_IS_SPAIN || false;
const IS_ES_ONLY = (window.YUXUS_COUNTRY_CODE === 'ES');

const T = { cart: CFG.t_cart };

// ============================================================
// SECCIÓN 5: PROMO BAR MESSAGES (configurable from theme editor)
// ============================================================
function initPromoBar() {
  var wrapper = document.getElementById('promoBarWrapper');
  if (!wrapper) return;

  // Messages are already rendered by Liquid from settings; read them from the DOM.
  var messageElements = Array.prototype.slice.call(wrapper.querySelectorAll('.promo-message'));
  if (messageElements.length === 0) return;

  var messages = messageElements.map(function(el) { return el.textContent; });
  var freeShippingIndex = typeof window.YUXUS_PROMO_FS_INDEX === 'number' ? window.YUXUS_PROMO_FS_INDEX : -1;
  var rotationMs = parseInt(wrapper.dataset.rotationMs, 10);
  if (isNaN(rotationMs) || rotationMs < 500) rotationMs = 3000;

  var currentMessageIndex = 0;

  window._promoBarState = {
    messages: messages,
    messageElements: messageElements,
    freeShippingIndex: freeShippingIndex,
    originalFreeShippingText: freeShippingIndex >= 0 ? messages[freeShippingIndex] : '',
    hasFreeShipping: false
  };

  // Arranca la rotación de los mensajes visibles. Puede llamarse más tarde (p.ej.
  // cuando un countdown de fecha fija termina y deja paso a los demás mensajes).
  function startPromoRotation() {
    // El "active" debe estar en un mensaje visible.
    var activeNow = wrapper.querySelector('.promo-message.active');
    if (!activeNow || activeNow.style.display === 'none') {
      if (activeNow) activeNow.classList.remove('active');
      for (var vi = 0; vi < messageElements.length; vi++) {
        if (messageElements[vi].style.display !== 'none') {
          messageElements[vi].classList.add('active');
          currentMessageIndex = vi;
          break;
        }
      }
    } else {
      currentMessageIndex = messageElements.indexOf(activeNow);
    }

    if (window._promoRotationStarted) return;
    window._promoRotationStarted = true;

    if (messageElements.length > 1) {
      setInterval(function() {
        var visible = messageElements.filter(function(el){ return el.style.display !== 'none'; });
        if (visible.length <= 1) return; // solo el countdown (u otro) visible -> no rotar
        var currentEl = messageElements[currentMessageIndex];
        if (currentEl) currentEl.classList.remove('active');
        var tries = 0;
        do {
          currentMessageIndex = (currentMessageIndex + 1) % messageElements.length;
          tries++;
        } while (messageElements[currentMessageIndex] &&
                 messageElements[currentMessageIndex].style.display === 'none' &&
                 tries <= messageElements.length);
        var nextEl = messageElements[currentMessageIndex];
        if (nextEl) nextEl.classList.add('active');
      }, rotationMs);
    }
  }
  window._startPromoRotation = startPromoRotation;

  // Si hay un countdown activo, NO rotamos: solo se ve el countdown.
  if (!window._promoCountdownActive) startPromoRotation();
}

// ============================================================
// PROMO BAR COUNTDOWN (token [countdown], configurable from theme editor)
// ============================================================
function initPromoCountdown() {
  var cfg = window.YUXUS_PROMO_COUNTDOWN;
  if (!cfg || !cfg.mode || cfg.mode === 'off') return;

  var spans = Array.prototype.slice.call(document.querySelectorAll('[data-promo-countdown]'));
  if (!spans.length) return;

  var loopMs = (parseInt(cfg.minutes, 10) || 15) * 60000;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(ms) {
    if (ms < 0) ms = 0;
    var t = Math.floor(ms / 1000);
    var d = Math.floor(t / 86400);
    var h = Math.floor((t % 86400) / 3600);
    var m = Math.floor((t % 3600) / 60);
    var s = t % 60;
    if (d > 0) return d + 'd ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    if (h > 0) return h + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    if (m > 0) return m + 'm ' + pad(s) + 's';
    return s + 's';
  }

  var getRemaining;
  if (cfg.mode === 'fixed') {
    var end = new Date(String(cfg.end || '').trim().replace(' ', 'T')).getTime();
    // No activo: fecha inválida o ya pasada -> el mensaje se queda oculto.
    if (isNaN(end) || end - Date.now() <= 0) return;
    getRemaining = function () { return end - Date.now(); };
  } else {
    // loop (reinicia en cada carga) / persistent (ancla en localStorage)
    var start;
    if (cfg.mode === 'persistent') {
      var KEY = 'yuxusPromoCountdownStart';
      try { start = parseInt(localStorage.getItem(KEY), 10); } catch (e) {}
      if (!start || isNaN(start)) {
        start = Date.now();
        try { localStorage.setItem(KEY, String(start)); } catch (e) {}
      }
    } else {
      start = Date.now();
    }
    // Al llegar a 0 vuelve a empezar (módulo loopMs).
    getRemaining = function () { return loopMs - ((Date.now() - start) % loopMs); };
  }

  // --- COUNTDOWN ACTIVO: en el banner solo se muestra el countdown ---
  window._promoCountdownActive = true;

  var cdMessages = spans.map(function (sp) { return sp.closest ? sp.closest('.promo-message') : null; }).filter(Boolean);
  var allMessages = Array.prototype.slice.call(document.querySelectorAll('#promoBarWrapper .promo-message'));
  var otherMessages = allMessages.filter(function (m) { return cdMessages.indexOf(m) === -1; });

  function setText(txt) { spans.forEach(function (sp) { sp.textContent = txt; }); }

  // Oculta el resto de mensajes y deja visible/activo solo el countdown.
  otherMessages.forEach(function (m) { m.style.display = 'none'; m.classList.remove('active'); });
  cdMessages.forEach(function (m) { m.style.display = ''; m.classList.add('active'); });

  var iv = null;
  function tick() {
    var rem = getRemaining();
    if (cfg.mode === 'fixed' && rem <= 0) {
      window._promoCountdownActive = false;
      if (iv) clearInterval(iv);
      if (cfg.hideAtZero) {
        // Countdown terminado: oculta el countdown y devuelve los mensajes normales.
        cdMessages.forEach(function (m) { m.style.display = 'none'; m.classList.remove('active'); });
        otherMessages.forEach(function (m) { m.style.display = ''; });
        if (typeof window._startPromoRotation === 'function') window._startPromoRotation();
      } else {
        setText(fmt(0));
      }
      return;
    }
    setText(fmt(rem));
  }
  tick();
  iv = setInterval(tick, 1000);
}

function updatePromoFreeShipping(cartTotalCents) {
  var state = window._promoBarState;
  if (!state || !state.messageElements) return;
  
  var threshold = window.YUXUS_FREE_SHIPPING_THRESHOLD || 0;
  var el = state.messageElements[state.freeShippingIndex];
  if (!el) return;
  
  if (cartTotalCents >= threshold && threshold > 0) {
    if (!state.hasFreeShipping) {
      el.textContent = window.YUXUS_FREE_SHIPPING_ACHIEVED || 'YOU HAVE FREE SHIPPING';
      el.classList.add('free-shipping-green');
      state.hasFreeShipping = true;
    }
  } else {
    if (state.hasFreeShipping) {
      el.textContent = state.originalFreeShippingText;
      el.classList.remove('free-shipping-green');
      state.hasFreeShipping = false;
    }
  }
}

initPromoCountdown();
initPromoBar();

// ============================================================
// SECCIÓN 6: PRELOAD IMAGES
// ============================================================
(function() {
  const urls = [
    'https://cdn.shopify.com/s/files/1/0715/1822/4676/files/WINDY_vertical_5_18MP.jpg?v=1762281857',
    'https://cdn.shopify.com/s/files/1/0715/1822/4676/files/01_8083_copia_2.webp?v=1756289690',
    'https://cdn.shopify.com/s/files/1/0715/1822/4676/files/joyas_campana_2_copia_1.webp?v=1752817685',
    'https://cdn.shopify.com/s/files/1/0715/1822/4676/files/Copia_de_LE_CLUB_6_copia_2.webp?v=1750933688',
    '/cdn/shop/files/BCC04566_copia.webp?v=1748421993',
    'https://cdn.shopify.com/s/files/1/0715/1822/4676/files/BCC07749_compressed.jpg?v=1753090655',
    'https://cdn.shopify.com/s/files/1/0715/1822/4676/files/Desplegable_VER_TODO.webp?v=1776088076'
  ];
  window.imageCache = window.imageCache || new Map();
  window.imageRefs = window.imageRefs || [];
  urls.forEach(url => { const img = new Image(); img.src = url; window.imageCache.set(url, img); window.imageRefs.push(img); });
})();

// ============================================================
// SECCIÓN 7: BODY PADDING POR TEMPLATE
// ============================================================
const rawPathname = window.location.pathname;
const pathname = rawPathname.replace(/^\/[a-z]{2}(\/|$)/, '/');
const isProductPage = pathname.includes('/products/');
const isHomePage = pathname === '/' || pathname === '';
const isCollectionPage = pathname.includes('/collections/');
/* Hero mode fuera de la home: lo marca Liquid (ajuste "Hero pages" de la sección).
   El path de forher se mantiene como fallback. */
const isForHerPage = window.YUXUS_HERO_PAGE === true || pathname === '/collections/forher' || pathname === '/collections/forher/';
if (isProductPage) document.body.classList.add('template-product');
else if (isHomePage) document.body.classList.add('template-index');
else if (isCollectionPage) document.body.classList.add('template-collection');

setTimeout(() => {
  const isMobile = window.innerWidth < 768;
  // Separacion de la barra inferior: suma altura al header, hay que devolversela al
  // contenido. Este inline style gana al CSS, asi que el calc() de alli no basta.
  // En producto no se suma: en escritorio la galeria va a sangre bajo el header.
  // En movil la barra va pegada al header (ver el bloque CSS del final), asi que
  // alli el hueco es 0 pase lo que pase en el ajuste.
  const bar2Gap = isMobile ? 0 : CFG.bar2Gap;
  const promoTopGap = document.documentElement.classList.contains('has-bottom-promo') ? 26 : 0;

  if (isHomePage || isForHerPage) {
    document.body.style.paddingTop = '0px';
  } else if (isProductPage) {
    /* 26 = la barra promo, que antes iba arriba; ahora va abajo (has-bottom-promo). */
    if (isMobile) { document.body.style.paddingTop = (128 - promoTopGap) + 'px'; }
    else { document.body.style.paddingTop = '5px'; }
  } else if (isCollectionPage) { 
    /* 90/60 eran numeros a mano y se quedaban CORTOS: el header + la barra de categorias
       ocupan 114px en escritorio y 110 en movil, asi que el grid arrancaba 30px por
       DEBAJO de la barra y cualquier aire que pusiera la seccion quedaba escondido.
       Se mide lo que ocupa de verdad el bloque fijo del header (su borde inferior; al
       ser fixed no cambia con el scroll) y se coge el mayor de los dos, asi nunca queda
       corto. El aire visible entre la barra y la primera fila lo pone luego la seccion
       del grid con --plp-top-gap (Theme settings > Collection grid).
       OJO con setProperty(..., 'important'): el CSS de mas arriba declara el padding del
       body con !important, y un !important de hoja de estilos gana a un estilo en linea
       normal. Sin esto el valor calculado no llegaba a aplicarse nunca. */
    /* 2026-10-15: franja blanca entre la barra de categorias y la rejilla (en movil fija,
       en escritorio medio segundo). Dos causas:
       - Se medía el borde inferior del CONTENEDOR, que durante la carga puede medir mas
         que lo que se ve (piezas del desplegable aun en el flujo) y el padding se quedaba
         largo hasta el siguiente 'load'. Ahora se mide la ultima barra VISIBLE: la de
         categorias recogida o, si no hay, el header.
       - Math.max con el numero a mano (90 en movil) dejaba aire de mas cuando el header
         real mide menos. El numero a mano ya solo vale si no se puede medir.
       Un ResizeObserver repite la medida cada vez que el header cambia de alto (fuentes,
       logo, carrusel que se monta tarde), sin esperar al 'load'. Con el desplegable abierto,
       menu o buscador no se toca: ahi el header crece a proposito. */
    const hdrBox = document.querySelector('.unified-header-container');
    const headerBottom = function () {
      if (!hdrBox) return 0;
      const bar = hdrBox.querySelector('.menu-carousel-bar');
      if (bar && bar.matches('.expanded, .showing-lists, .showing-text-lists, .force-show')) return -1;
      if (bar && bar.offsetHeight > 0 && getComputedStyle(bar).display !== 'none' && getComputedStyle(bar).opacity !== '0') return bar.getBoundingClientRect().bottom;
      const sh = hdrBox.querySelector('.site-header');
      return sh ? sh.getBoundingClientRect().bottom : hdrBox.getBoundingClientRect().bottom;
    };
    const padCollection = function () {
      /* Ya scrolleado: se deja el valor que habia (no hace falta cambiarlo). */
      if ((window.scrollY || window.pageYOffset || 0) > 10) return;
      const b = document.body;
      if (b.classList.contains('menu-open') || b.classList.contains('mobile-search-active') || b.classList.contains('desktop-search-active')) return;
      const mob = window.innerWidth < 768;
      const base = (mob ? 90 - promoTopGap : 60) + (mob ? 0 : bar2Gap);
      const hb = headerBottom();
      if (hb < 0) return;
      const measured = Math.ceil(hb);
      document.body.style.setProperty('padding-top', (measured > 0 ? measured : base) + 'px', 'important');
    };
    padCollection();
    window.addEventListener('load', padCollection);
    window.addEventListener('resize', padCollection);
    if (hdrBox && 'ResizeObserver' in window) {
      const ro = new ResizeObserver(function () { padCollection(); });
      ro.observe(hdrBox);
      const sh0 = hdrBox.querySelector('.site-header'); if (sh0) ro.observe(sh0);
      const bar0 = hdrBox.querySelector('.menu-carousel-bar'); if (bar0) ro.observe(bar0);
    }
  } else { 
    document.body.style.paddingTop = (80 + bar2Gap - promoTopGap) + 'px';
  }
  document.body.style.marginTop = '0';
}, 100);

// ============================================================
// HERO MODE - TRANSPARENT HEADER
// ============================================================
if (isHomePage || isForHerPage) {
  document.body.classList.add('hero-page');
  
  var heroActive = false;
  var heroSearchPaused = false;
  var heroDropdownPaused = false;
  
  window._pauseHeroForDropdown = function() {
    if (!document.body.classList.contains('header-hero-mode')) return;
    heroDropdownPaused = true;
    document.body.classList.add('hero-dropdown-open');
  };
  window._resumeHeroFromDropdown = function() {
    if (!heroDropdownPaused) return;
    heroDropdownPaused = false;
    document.body.classList.remove('hero-dropdown-open');
    var scrollY = getScrollY();
    heroThreshold = getHeroThreshold();
    if (scrollY > heroThreshold && heroActive) {
      document.body.classList.remove('header-hero-mode');
      heroActive = false;
    }
  };
  
  function getHeroThreshold() {
    if (isHomePage) {
      var heroBlock = document.getElementById('ss-home-viewall');
      if (heroBlock) return heroBlock.offsetHeight - 80;
      /* Sin ese bloque (la home ya no lo usa) el umbral se saca del BANNER: la primera
         sección con altura real de la home. Así el header se queda transparente hasta
         que el scroll llega al grid de productos que va justo debajo, y no hay que
         tocar nada si mañana el banner es otra sección. */
      var homeSections = document.querySelectorAll('#MainContent > .shopify-section');
      for (var hs = 0; hs < homeSections.length; hs++) {
        var banner = homeSections[hs];
        if (banner.offsetHeight < 120) continue; // secciones vacías o barras finas
        return banner.getBoundingClientRect().top + getScrollY() + banner.offsetHeight - 80;
      }
    } else {
      /* La landing puede pedir el comportamiento de la home (fondo sólido al primer
         scroll) desde su ajuste "Header turns solid as soon as you scroll": entonces
         vale el umbral corto y no esperamos a pasar el primer bloque. */
      if (document.querySelector('[data-cl-header-early-solid]')) return 50;
      /* Landings (collection-landing): el header se queda transparente mientras el
         hero de arriba está en pantalla, igual que en la home. Si la página no
         empieza por un hero, vale el umbral corto de siempre. */
      var landingHero = document.querySelector('.cl-hero, .cl-pvid, .cl-zara-stage');
      if (landingHero && landingHero.getBoundingClientRect().top + window.pageYOffset < 120) {
        return landingHero.offsetHeight - 80;
      }
    }
    return 50;
  }
  
  var initialScrollY = getScrollY();
  var heroThreshold = getHeroThreshold();
  
  if (initialScrollY <= heroThreshold) {
    document.body.classList.add('header-hero-mode');
    heroActive = true;
  }
  
  function handleHeroScroll() {
    if (heroSearchPaused || heroDropdownPaused) return;
    var scrollY = getScrollY();
    heroThreshold = getHeroThreshold();

    if (scrollY > heroThreshold && heroActive) {
      document.body.classList.remove('header-hero-mode');
      heroActive = false;
    } else if (scrollY <= heroThreshold && !heroActive) {
      document.body.classList.add('header-hero-mode');
      heroActive = true;
    }
  }
  
  var heroObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.attributeName === 'class') {
        var isSearchActive = document.body.classList.contains('desktop-search-active') || document.body.classList.contains('mobile-search-active');
        var isMenuOpen = document.body.classList.contains('menu-open');
        var shouldPause = isSearchActive || isMenuOpen;
        
        if (shouldPause && !heroSearchPaused) {
          document.body.classList.remove('header-hero-mode');
          heroSearchPaused = true;
        } else if (!shouldPause && heroSearchPaused) {
          heroSearchPaused = false;
          var scrollY = getScrollY();
          if (scrollY <= heroThreshold) {
            document.body.classList.add('header-hero-mode');
            heroActive = true;
          }
        }
      }
    });
  });
  heroObserver.observe(document.body, { attributes: true });
  
  var heroScrollTicking = false;
  getScrollTarget().addEventListener('scroll', function() {
    if (!heroScrollTicking) {
      requestAnimationFrame(function() {
        handleHeroScroll();
        heroScrollTicking = false;
      });
      heroScrollTicking = true;
    }
  }, { passive: true });
}

// ============================================================
// SECCIÓN 8: MENU CAROUSEL NOTIFICATION
// ============================================================
function markCurrentPageInMenu() {
  const currentPath = window.location.pathname.replace(/\/$/, '');
  document.querySelectorAll('.menu-carousel-item').forEach(item => {
    const itemHref = item.getAttribute('href') || '';
    let p = '';
    try { p = new URL(itemHref, location.origin).pathname.replace(/\/$/, ''); } catch (e) {}
    item.classList.toggle('current-page', p !== '' && p !== '/' && p === currentPath);
  });
}

function getCookie(name) { const value = `; ${document.cookie}`; const parts = value.split(`; ${name}=`); if (parts.length === 2) return parts.pop().split(';').shift(); return null; }
function setCookie(name, value, days) { const date = new Date(); date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/;SameSite=Lax`; }

function handleNewArrivalsNotification() {
  const newArrivalsLink = document.querySelector('a[href="' + CFG.root + '/collections/new-arrivals"].menu-carousel-item');
  if (!newArrivalsLink) return;
  const hasVisited = getCookie('new_arrivals_visited');
  if (!hasVisited) newArrivalsLink.classList.add('has-notification');
  newArrivalsLink.addEventListener('mousedown', function() { setCookie('new_arrivals_visited', 'true', 30); newArrivalsLink.classList.remove('has-notification'); });
  newArrivalsLink.addEventListener('touchstart', function() { setCookie('new_arrivals_visited', 'true', 30); newArrivalsLink.classList.remove('has-notification'); }, { passive: true });
}

markCurrentPageInMenu();
handleNewArrivalsNotification();

// ============================================================
// SECCIÓN 9: SCROLL LOCK
// ============================================================
let scrollPosition = 0;
function lockScroll() { scrollPosition = getScrollY(); document.body.classList.add('menu-open'); if (!_isInApp) { document.body.style.top = `-${scrollPosition}px`; } document.documentElement.style.scrollBehavior = 'auto'; }
function unlockScroll() { document.body.classList.remove('menu-open'); document.body.style.top = ''; document.documentElement.style.scrollBehavior = ''; if (_isInApp) { document.body.scrollTop = scrollPosition; } else { window.scrollTo(0, scrollPosition); } }

// ============================================================
// SECCIÓN 10: CART COUNT SYNC
// ============================================================
// 2026-11-03 "el numero a veces no actualiza (2 y tengo 8)": cada cambio lanzaba su propio
// /cart.js 250 ms despues y la respuesta que llegaba la ULTIMA ganaba aunque fuera la mas
// vieja -> se quedaba un numero antiguo. Ahora: (1) solo pinta la lectura mas reciente
// (cntSeq), (2) los cambios seguidos se agrupan en una sola lectura (debounce), (3) el
// carrito, que ya lee /cart.js, empuja su dato con window.YX_SET_CART_COUNT, (4) al volver
// atras desde la cache del navegador (bfcache) se relee, y (5) se detectan tambien las
// llamadas con Request/URL, no solo con texto.
let cart = 0;
let cntSeq = 0, cntTimer = null;
const setCnt = n => { document.querySelectorAll('.cart-count-text').forEach(el => el.textContent = `${T.cart} ( ${n} )`); const d = document.getElementById('desktopCartLink'); if (d) d.textContent = `${T.cart} ( ${n} )`; };
const applyCart = j => { if (!j) return; cart = j.item_count || 0; setCnt(cart); updatePromoFreeShipping(j.total_price || 0); };
const sync = () => {
  const seq = ++cntSeq;
  return fetch('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
    .then(r => r.json())
    .then(j => { if (seq === cntSeq) applyCart(j); })
    .catch(() => {});
};
const syncSoon = () => { clearTimeout(cntTimer); cntTimer = setTimeout(sync, 200); };
// El carrito (refreshCart) ya trae /cart.js: se usa si esa lectura empezo DESPUES del ultimo
// cambio terminado y no hay otro cambio en curso (si no, podria ser un dato viejo).
let cntPending = 0, cntLastDone = 0;
window.YX_SET_CART_COUNT = function (j, readStartedAt) {
  if (cntPending > 0) return;
  if (readStartedAt && readStartedAt < cntLastDone) return;
  cntSeq++; applyCart(j);
};
sync();
window.addEventListener('pageshow', e => { if (e.persisted) sync(); });
document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') syncSoon(); });

(function() {
  var _origFetch = window.fetch;
  window.fetch = function() {
    var a0 = arguments[0];
    var url = typeof a0 === 'string' ? a0 : (a0 && (a0.url || a0.href)) || '';
    var isCartChange = url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/clear') !== -1;
    if (isCartChange) {
      cntSeq++; // invalida cualquier lectura anterior a este cambio
      cntPending++;
      var done = function () { cntPending = Math.max(0, cntPending - 1); cntLastDone = Date.now(); syncSoon(); };
      return _origFetch.apply(this, arguments).then(function(response) {
        done();
        return response;
      }, function(err) { done(); throw err; });
    }
    return _origFetch.apply(this, arguments);
  };
})();


// ============================================================
// SECCIÓN 11: MENU CAROUSEL HOVER (DESKTOP)
// ============================================================
const menuCarouselBar = document.getElementById('menuCarouselBar');
const menuCarouselWrapper = document.getElementById('menuCarouselWrapper');
const originalCarouselContent = menuCarouselWrapper ? menuCarouselWrapper.innerHTML : '';

// === Dropdown content loaded dynamically from <template id="hbc-tpl-N" data-type="text|image"> tags ===
const menuContents = {};
document.querySelectorAll('template[id^="hbc-tpl-"]').forEach(function(tpl) {
  var idx = tpl.id.replace('hbc-tpl-', '');
  menuContents['dd-' + idx] = {
    hasImages: tpl.dataset.type === 'image',
    isLookbook: false,
    content: tpl.innerHTML
  };
});

let currentActiveMenu = null;
let hoverTimeout = null;
let isTransitioning = false;

function showMenuContent(menuType) {
  if (document.body.classList.contains('header-hero-mode') && window._pauseHeroForDropdown) {
    window._pauseHeroForDropdown();
  }
  if (currentActiveMenu === menuType || isTransitioning) return;
  isTransitioning = true;
  document.querySelectorAll('.header-menu__item').forEach(item => item.classList.remove('active'));
  const activeItem = document.querySelector(`.header-menu__item[data-menu="${menuType}"]`);
  if (activeItem) activeItem.classList.add('active');
  currentActiveMenu = menuType;
  const menuData = menuContents[menuType];
  if (menuData && menuCarouselWrapper) {
    menuCarouselWrapper.innerHTML = menuData.content;
    if (menuData.hasImages) { menuCarouselBar.classList.add('expanded'); menuCarouselBar.classList.remove('showing-text-lists'); }
    else { menuCarouselBar.classList.remove('expanded'); menuCarouselBar.classList.add('expanded'); menuCarouselBar.classList.add('showing-text-lists'); }
    isTransitioning = false;
  }
}

function restoreOriginalContent() {
  if (isTransitioning) return;
  isTransitioning = true;
  document.querySelectorAll('.header-menu__item').forEach(item => item.classList.remove('active'));
  currentActiveMenu = null;
  if (menuCarouselWrapper) menuCarouselWrapper.innerHTML = originalCarouselContent;
  if (menuCarouselBar) { menuCarouselBar.classList.remove('expanded'); menuCarouselBar.classList.remove('showing-text-lists'); }
  markCurrentPageInMenu();
  handleNewArrivalsNotification();
  
  if (window._resumeHeroFromDropdown) window._resumeHeroFromDropdown();
  
  isTransitioning = false;
}

if (window.innerWidth >= 1200 && menuCarouselBar) {
  const HOVER_CLOSE_DELAY = 0;
  const menuItems = document.querySelectorAll('.header-menu__item[data-menu]');
  let lastMouseY = 0;
  let lastMouseX = 0;
  
  document.addEventListener('mousemove', (e) => { lastMouseY = e.clientY; lastMouseX = e.clientX; }, { passive: true });
  
  function isMouseInMenuZone() {
    const itemRects = Array.from(menuItems).map(el => el.getBoundingClientRect());
    const carouselRect = menuCarouselBar.getBoundingClientRect();
    
    for (const rect of itemRects) {
      if (lastMouseX >= rect.left && lastMouseX <= rect.right && lastMouseY >= rect.top && lastMouseY <= rect.bottom) return true;
    }
    if (carouselRect.height > 0 && lastMouseX >= carouselRect.left && lastMouseX <= carouselRect.right && lastMouseY >= carouselRect.top && lastMouseY <= carouselRect.bottom) return true;
    
    for (const rect of itemRects) {
      if (lastMouseX >= rect.left && lastMouseX <= rect.right && lastMouseY >= rect.bottom && lastMouseY <= rect.bottom + 15) return true;
    }
    
    return false;
  }
  
  function scheduleClose() {
    clearTimeout(hoverTimeout);
    hoverTimeout = setTimeout(() => {
      if (!isMouseInMenuZone()) restoreOriginalContent();
    }, HOVER_CLOSE_DELAY);
  }
  
  menuItems.forEach(item => {
    const menuType = item.getAttribute('data-menu');
    item.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      showMenuContent(menuType);
    });
    item.addEventListener('mouseleave', () => { scheduleClose(); });
  });
  menuCarouselBar.addEventListener('mouseenter', () => { clearTimeout(hoverTimeout); });
  menuCarouselBar.addEventListener('mouseleave', () => { scheduleClose(); });
}

// ============================================================
// SECCIÓN 12: ICON EXPANDABLE HOVER
// ============================================================
document.querySelectorAll('.icon-expandable').forEach(icon => {
  let timeoutId;
  icon.addEventListener('mouseenter', function() { clearTimeout(timeoutId); timeoutId = setTimeout(() => { icon.classList.add('hover-active'); }, 50); });
  icon.addEventListener('mouseleave', function() { clearTimeout(timeoutId); timeoutId = setTimeout(() => { icon.classList.remove('hover-active'); }, 100); });
});

// ============================================================
// SECCIÓN 13: MOBILE MENU
// ============================================================
const btn = document.querySelector('.btn-menu');
const overlay = document.getElementById('mobileMenuOverlay');
const unifiedContainer = document.getElementById('unifiedHeader');

function updateOverlayPosition() {
  if (overlay) {
    const siteHeader = document.querySelector('.site-header');
    const promoHeight = document.documentElement.classList.contains('has-bottom-promo') ? 0 : 26;
    const headerHeight = siteHeader ? siteHeader.offsetHeight : 62;
    overlay.style.top = (promoHeight + headerHeight) + 'px';
  }
}

if (btn && overlay) {
  btn.addEventListener('click', () => {
    btn.classList.toggle('active');
    overlay.classList.toggle('active');
    if (btn.classList.contains('active')) { 
      const promoBar = document.getElementById('promoBarWrapper');
      if (promoBar) promoBar.classList.remove('scroll-hidden');
      updateOverlayPosition();
      lockScroll(); 
      if (unifiedContainer) unifiedContainer.classList.add('mobile-menu-active'); 
    }
    else { unlockScroll(); if (unifiedContainer) unifiedContainer.classList.remove('mobile-menu-active'); }
  });
}

function toggleSubmenu(wrapper) {
  const submenu = wrapper.querySelector('.mobile-submenu');
  const toggle = wrapper.querySelector('.mobile-submenu-toggle');
  if (submenu) {
    document.querySelectorAll('.mobile-submenu.active').forEach(otherSubmenu => { if (otherSubmenu !== submenu) { otherSubmenu.classList.remove('active'); const otherToggle = otherSubmenu.closest('li').querySelector('.mobile-submenu-toggle'); if (otherToggle) otherToggle.classList.remove('active'); } });
    submenu.classList.toggle('active');
    if (toggle) toggle.classList.toggle('active');
  }
}

document.querySelectorAll('.mobile-submenu-toggle').forEach(toggle => { toggle.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); toggleSubmenu(toggle.closest('li')); }); });
document.querySelectorAll('.mobile-menu-link-expandable').forEach(link => { link.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); toggleSubmenu(link.closest('li')); }); });

// ============================================================
// SECCIÓN 14: TOUCH MOVE PREVENTION
// ============================================================
document.addEventListener('touchmove', function(e) { 
  if (e.target.closest('[class*="orbe"]') || e.target.closest('[class*="orbito"]') || e.target.closest('[id*="orbe"]') || e.target.closest('[id*="orbito"]') || e.target.closest('[class*="md-"]') || e.target.closest('[id*="md-"]') || e.target.closest('[class*="market"]') || e.target.closest('.yuxus-modal-backdrop') || e.target.closest('.yuxus-modal')) {
    return;
  }
  
  if (document.body.classList.contains('mobile-search-active')) {
    if (e.target.closest('#mobileSearchResultsCarousel') || e.target.closest('.mobile-search-results-carousel')) {
      return;
    } else {
      e.preventDefault();
    }
    return;
  }
  
  if (document.body.classList.contains('menu-open')) { 
    if (!e.target.closest('.mobile-menu-overlay') && !e.target.closest('.search-overlay-inner')) {
      e.preventDefault();
    }
  } 
}, { passive: false });

// ============================================================
// SECCIÓN 15: SLIDECART UPDATE CALLBACK
// ============================================================
window.SLIDECART_UPDATED = function(cart) {
  cntSeq++; // dato fresco: que no lo pise una lectura vieja en vuelo
  const count = cart.item_count || 0;
  document.querySelectorAll('.cart-count-text').forEach(el => { el.textContent = `${T.cart} ( ${count} )`; });
  const desktopLink = document.getElementById('desktopCartLink');
  if (desktopLink) desktopLink.textContent = `${T.cart} ( ${count} )`;
  updatePromoFreeShipping(cart.total_price || 0);
};

// ============================================================
// FIN DEL ARCHIVO
// ============================================================

});
